import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
/* Assets */
import iconClose from "../../../../src/assets/icons/close.svg";
import bookmark_added from "../../../../src/assets/icons/bookmark_added.svg";
/* Components */
import ReactSelect from "react-select";
import Button from "../../button/button";
import CompetenciesFields from "../../competencies/competencies";

const SkillSelector = ({
  isOpen,
  onClose,
  customClassName,
  subjectAreas,
  competences,
  performances,
  SelectStyles,
  grade,
  subjectWatch,
  data,
  competencesStore,
  showSubjectField
}) => {
  const [shouldRender, setShouldRender] = useState(isOpen);
  const { t } = useTranslation();
  const { control, setValue } = useFormContext();

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
    }
  }, [isOpen]);

  const handleClose = () => {
    setShouldRender(false);
    onClose();
  };

  const subjectAreaMapper = () => {
    let list = subjectAreas;
   if(grade) {
    list = list.map(e => {
      const findCompetenteData = data.find(cd => cd.grade_level.id === grade && cd.subject_area.id === e.value);
      if(findCompetenteData?.grade_level.name.includes('primaria') || findCompetenteData?.grade_level.name.includes('secundaria')){
        return {...e, label: `${e.label} (${findCompetenteData.grade_level.name.includes('primaria') ? 'Primaria' : 'Secundaria'})` };
      }
      return e
    })
    }
    return list;
  }

  if (!shouldRender) return null;

  return (
    <div
      className={`absolute z-[900] w-full h-full top-0 left-0 items-center justify-center transition-all bg-DarkBlue-600/90 backdrop-blur-sm backdrop-saturate-200 rounded-4 overflow-hidden ${
        isOpen ? "flex" : "hidden"
      }`}
    >
      <div
        className={classNames(
          `relative sm-max:max-w-[95%] max-w-1/2 max-h-[97%] bg-DarkBlue-700 p-0 pt-6 pb-4 sm-max:px-4 flex flex-col flex-1 justify-center items-center gap-4 rounded-4 overflow-hidden shadow-2xl transition-all delay-300  ${
            isOpen ? "translate-y-0" : "translate-y-[100%]"
          }`,
          customClassName
        )}
      >
        {onClose && (
          <button
            className="absolute top-0 right-0 cursor-pointer p-4 bg-DarkBlue-700 rounded-4"
            onClick={handleClose}
          >
            <img src={iconClose} alt="" />
          </button>
        )}
        <div className="w-full h-full overflow-y-auto p-4 sm-max:p-0">
          {/* Área curricular */}
          {showSubjectField && (
            <div className="input-text ">
              <label className="input-label">
                {t("formulario_edas_campo_area_curricular_label")}
              </label>
              <label className="input-instruction !min-h-auto !pb-2">
                {t("formulario_edas_campo_area_curricular_modal_instruction")}
              </label>
              <Controller
                name="areaCurricular"
                control={control}
                rules={{ required: t("campo_requerido") }}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    options={subjectAreaMapper()}
                    value={
                      subjectAreas.find(
                        (option) => option.value === field.value
                      ) || null
                    }
                    placeholder={t(
                      "formulario_edas_campo_placeholder_area_curricular"
                    )}
                    onChange={(option) => {
                      const newValue = option ? option.value : null;
                      setValue("areaCurricular", newValue);
                      field.onChange(newValue);
                    }}
                    styles={SelectStyles}
                    isMulti={false}
                    maxMenuHeight={400}
                    menuPlacement="bottom"
                  />
                )}
              />
            </div>
          )}
          {/* Competencias */}
          <CompetenciesFields
            competencesStore={competencesStore}
            competenceCount={1}
            grade={grade}
            subject={subjectWatch}
            data={data}
          />
          {/* Acciones */}
          <div className="flex flex-row sm-max:flex-col gap-4 w-full items-center justify-center pt-12 pb-6">
            <div className="flex items-center gap-2">
              <div className="h-6 w-6">
                <img src={bookmark_added} className="" alt="" />
              </div>
              <span className="text-Grey-500">
                {t("modal_edas_texto_desempenos_agregados")}
              </span>
              <span className="text-LightBlue-500 font-bold">
                +{competencesStore.performances.length}
              </span>
            </div>
          </div>
          <div className="w-full mt-8 flex items-center justify-center">
            <Button
              label={t("modal_edas_texto_boton_cerrar")}
              variant="primary"
              onClick={handleClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkillSelector;
